import { TemplateModelState } from "./templateManager.types";

export const state: TemplateModelState = {
  templates: null,
  loading: false,
  pagination: null
};
